<template>
      <div class="block10">
          <!-- 返回 -->
          <div class="return">
              <router-link to="/"><span class="arrow"></span>返回首页</router-link>
          </div>
          <!-- 返回 -->
          <!-- 内容 -->
          <div class="container">
            <h2 class="title1" id="zhishideng">指示灯</h2>
            <div class="container-content">
              <p>如果某个指示灯在应该亮起时没有亮起，请联系您的经销商检查故障。</p>
              <img src="./img/p01901.png" alt="" width="100%">
              <p>
                <router-link to="/block31/jgzsddl">如果FI故障指示灯（MIL）在发动机运转期间亮起，请点击此处</router-link>
              </p>
            </div>
            <div class="foot-btn">
              <div class="prev">
                <router-link to="/block9">上一页</router-link>
              </div>
              <div class="next">
                <router-link to="/block11">下一页</router-link>
              </div>
          </div>
          </div>
     
      </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);
    // 图像热区
    // imagehoverclick("boxmap");
  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>